"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$CreateSignerRequest = void 0;
exports.$CreateSignerRequest = {
    properties: {
        network: {
            type: 'Enum',
            isRequired: true,
        },
        transactions: {
            type: 'array',
            contains: {
                type: 'one-of',
                contains: [{
                        type: 'SignerTransactionDto',
                    }],
            },
            isRequired: true,
        },
        dAppMetadata: {
            type: 'DAppMetadatRequest',
        },
    },
};
